import { Controller } from "@hotwired/stimulus"
import { showPaymentProcessingOverlay } from "../payment_processing_overlay"

// Tela de "Processando pagamento" em tela cheia ao clicar em pagar — mesmo padrão
// comprovado da venda direta/e-commerce: injeta um overlay FRESCO no <body> (que
// sobrevive às respostas turbo que trocam #main). Dispara no clique do botão (o
// submit é reescrito pelo prepare-form, então o evento submit não é confiável).
export default class extends Controller {
  show() {
    showPaymentProcessingOverlay()
  }
}
